export const EMAIL_INPUT_PATTERN = String.raw`^[\w.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$`
